const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      solutions: 'Solutions',
      about: 'A propos',
      contact: 'Contact',
    },
    hero: {
      title: 'La solution digitale',
      titleHighlight: 'pour la restauration',
      subtitle: 'Simplifiez la gestion de votre restaurant avec notre ecosysteme complet : caisse, borne de commande, QR code, gestion de cuisine et bien plus.',
      cta: 'Decouvrir nos solutions',
      ctaSecondary: 'Nous contacter',
    },
    solutions: {
      title: 'Nos Solutions',
      subtitle: 'Un ecosysteme complet pour digitaliser votre restaurant',
      caisse: {
        name: 'Caisse Enregistreuse',
        desc: 'Systeme de caisse tactile performant avec gestion des paiements multiples, tickets, et suivi en temps reel.',
      },
      borne: {
        name: 'Borne de Commande',
        desc: 'Borne interactive permettant a vos clients de passer commande en toute autonomie.',
      },
      qrcode: {
        name: 'Commande QR Code',
        desc: 'Vos clients scannent un QR code et commandent directement depuis leur smartphone.',
      },
      serveur: {
        name: 'App Serveur',
        desc: 'Application mobile pour vos serveurs : prise de commande, gestion des tables en temps reel.',
      },
      cuisine: {
        name: 'Ecran Cuisine',
        desc: 'Affichage des commandes en cuisine avec suivi des preparations et notifications.',
      },
      erp: {
        name: 'ERP / Gestion Stock',
        desc: 'Gestion complete des stocks, production, fournisseurs et recettes.',
      },
      stats: {
        name: 'Statistiques Mobile',
        desc: 'Suivez vos performances en temps reel depuis votre smartphone : CA, commandes, tendances.',
      },
      orb: {
        name: 'ORB - Affichage Commandes',
        desc: 'Ecran d\'affichage des numeros de commandes pretes pour vos clients, avec notifications sonores.',
      },
      livraison: {
        name: 'Application Livraison',
        desc: 'Application mobile Android & iOS pour vos livreurs : suivi des commandes, itineraires et statuts en temps reel.',
      },
      fidelite: {
        name: 'Systeme de Fidelite',
        desc: 'Programme de fidelite integre : points, recompenses, historique client et notifications automatiques.',
      },
      siteweb: {
        name: 'Site Web & App iOS, Android',
        desc: 'Site vitrine et applications mobiles iOS & Android pour vos clients, commande en ligne et notifications.',
      },
      cloud: {
        name: 'Cloud & Admin',
        desc: 'Gestion centralisee multi-boutiques avec synchronisation cloud en temps reel.',
      },
    },
    features: {
      title: 'Pourquoi ScanEat ?',
      subtitle: 'Des avantages concrets pour votre business',
      realtime: {
        title: 'Temps reel',
        desc: 'Synchronisation instantanee entre tous vos appareils et applications.',
      },
      multistore: {
        title: 'Multi-boutiques',
        desc: 'Gerez plusieurs points de vente depuis une seule interface cloud.',
      },
      easy: {
        title: 'Simple a utiliser',
        desc: 'Interface intuitive, prise en main rapide sans formation complexe.',
      },
      secure: {
        title: 'Securise',
        desc: 'Donnees chiffrees, sauvegardes automatiques, acces securise.',
      },
    },
    about: {
      title: 'A propos de ScanEat',
      text1: 'ScanEat est une solution technologique tunisienne dediee a la digitalisation de la restauration.',
      text2: 'Notre mission est de fournir aux restaurateurs des outils modernes, performants et accessibles pour optimiser leur activite au quotidien.',
      text3: 'De la prise de commande au suivi des stocks, en passant par les statistiques et le cloud, ScanEat couvre tous les besoins de votre etablissement.',
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Une question ? Un projet ? N\'hesitez pas a nous contacter.',
      email: 'Email',
      phone: 'Telephone',
      address: 'Adresse',
      addressValue: 'Tunisie',
      form: {
        name: 'Nom complet',
        email: 'Email',
        message: 'Votre message',
        send: 'Envoyer',
      },
    },
    footer: {
      rights: 'Tous droits reserves.',
      solutions: 'Solutions',
      company: 'Entreprise',
      legal: 'Mentions legales',
      privacy: 'Politique de confidentialite',
    },
  },
  en: {
    nav: {
      home: 'Home',
      solutions: 'Solutions',
      about: 'About',
      contact: 'Contact',
    },
    hero: {
      title: 'The digital solution',
      titleHighlight: 'for restaurants',
      subtitle: 'Simplify your restaurant management with our complete ecosystem: POS, ordering kiosk, QR code, kitchen management and more.',
      cta: 'Discover our solutions',
      ctaSecondary: 'Contact us',
    },
    solutions: {
      title: 'Our Solutions',
      subtitle: 'A complete ecosystem to digitize your restaurant',
      caisse: {
        name: 'POS System',
        desc: 'High-performance touchscreen POS with multi-payment support, receipts, and real-time tracking.',
      },
      borne: {
        name: 'Self-Order Kiosk',
        desc: 'Interactive kiosk allowing your customers to place orders independently.',
      },
      qrcode: {
        name: 'QR Code Ordering',
        desc: 'Customers scan a QR code and order directly from their smartphone.',
      },
      serveur: {
        name: 'Waiter App',
        desc: 'Mobile app for your waiters: order taking, real-time table management.',
      },
      cuisine: {
        name: 'Kitchen Display',
        desc: 'Kitchen order display with preparation tracking and notifications.',
      },
      erp: {
        name: 'ERP / Stock Management',
        desc: 'Complete stock, production, supplier and recipe management.',
      },
      stats: {
        name: 'Mobile Statistics',
        desc: 'Track your performance in real-time from your smartphone: revenue, orders, trends.',
      },
      orb: {
        name: 'ORB - Order Display',
        desc: 'Display screen showing ready order numbers for your customers, with sound notifications.',
      },
      livraison: {
        name: 'Delivery App',
        desc: 'Android & iOS mobile app for your delivery drivers: order tracking, routes and real-time status.',
      },
      fidelite: {
        name: 'Loyalty System',
        desc: 'Integrated loyalty program: points, rewards, customer history and automatic notifications.',
      },
      siteweb: {
        name: 'Website & iOS, Android App',
        desc: 'Showcase website and mobile apps for iOS & Android, online ordering and notifications.',
      },
      cloud: {
        name: 'Cloud & Admin',
        desc: 'Centralized multi-store management with real-time cloud synchronization.',
      },
    },
    features: {
      title: 'Why ScanEat?',
      subtitle: 'Real benefits for your business',
      realtime: {
        title: 'Real-time',
        desc: 'Instant synchronization between all your devices and applications.',
      },
      multistore: {
        title: 'Multi-store',
        desc: 'Manage multiple locations from a single cloud interface.',
      },
      easy: {
        title: 'Easy to use',
        desc: 'Intuitive interface, quick onboarding without complex training.',
      },
      secure: {
        title: 'Secure',
        desc: 'Encrypted data, automatic backups, secure access.',
      },
    },
    about: {
      title: 'About ScanEat',
      text1: 'ScanEat is a Tunisian technology solution dedicated to digitizing the restaurant industry.',
      text2: 'Our mission is to provide restaurateurs with modern, efficient, and accessible tools to optimize their daily operations.',
      text3: 'From order taking to stock tracking, statistics and cloud management, ScanEat covers all your establishment\'s needs.',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have a question? A project? Don\'t hesitate to reach out.',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      addressValue: 'Tunisia',
      form: {
        name: 'Full name',
        email: 'Email',
        message: 'Your message',
        send: 'Send',
      },
    },
    footer: {
      rights: 'All rights reserved.',
      solutions: 'Solutions',
      company: 'Company',
      legal: 'Legal notice',
      privacy: 'Privacy policy',
    },
  },
};

export default translations;
